export interface ITriggerAreaDto {
    type: string;
    zoneId: string;
    datetime: string;
    tripId: string;
    position: {
        latitude: string;
        longitude: string;
    };
}
